import { render, staticRenderFns } from "./CoffInputMoney.vue?vue&type=template&id=0673ae64&scoped=true"
import script from "./CoffInputMoney.vue?vue&type=script&lang=js"
export * from "./CoffInputMoney.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0673ae64",
  null
  
)

export default component.exports